import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["_templatePath"];
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import Small from 'UIComponents/elements/Small';
import UIFormLabel from 'UIComponents/form/UIFormLabel';
import UILink from 'UIComponents/link/UILink';
import ColorPickerField from './ColorPickerField';
import { getKnowledgeBasePreviewUrl } from '../../utils/previewUtils';
import { useCurrentKnowledgeBaseId } from '../../knowledge-base/hooks/knowledgeBaseHooks';
import { selectTemplateEditorLanguage } from '../../selectors/templateSettings';
import { useAppSelector } from '../../utils/hooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ColorWithMobilePreviewField = props => {
  const {
      _templatePath: templatePath
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const currentKnowledgeBaseId = useCurrentKnowledgeBaseId();
  const templateEditorLanguage = useAppSelector(selectTemplateEditorLanguage);
  const previewUrl = getKnowledgeBasePreviewUrl(templatePath, templateEditorLanguage, currentKnowledgeBaseId);
  const handleClick = e => {
    e.preventDefault();
    window.open(previewUrl, 'targetWindow', 'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=375,height=812,left=400');
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UIFormLabel, {
      className: "p-x-0",
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        elements: {
          Link: ({
            children
          }) => /*#__PURE__*/_jsx(Small, {
            children: /*#__PURE__*/_jsx(UILink, {
              className: "m-left-2",
              external: true,
              onClick: handleClick,
              children: children
            })
          })
        },
        message: "knowledgeContentUI.templateEditor.fields.mobileNavMenuColor.label_jsx"
      })
    }), /*#__PURE__*/_jsx(ColorPickerField, Object.assign({}, rest))]
  });
};
export default ColorWithMobilePreviewField;